import { DetailDataTypeEnum, SearchDataTypeEnum } from '@/common/services/swagger/index.defs';

export enum InternalDataTypeEnum {
  'ProductPreview' = 'ProductPreview',
  'FavoriteProductCategories' = 'FavoriteProductCategories',
  'FavoritePartCategories' = 'FavoritePartCategories',
  'FavoriteViews' = 'FavoriteViews',
  'Translations' = 'Translations',
  'RelatedProducts' = 'RelatedProducts',
  'ProductCompare' = 'ProductCompare',
}

export const DataType = { ...SearchDataTypeEnum, ...DetailDataTypeEnum, ...InternalDataTypeEnum };
export type DataType = DetailDataTypeEnum | SearchDataTypeEnum | InternalDataTypeEnum;
